
 var admin="https://x8f3h6lx4h.execute-api.ap-south-1.amazonaws.com/dev/api/";  //admin

 var service="https://24txld2sb5.execute-api.ap-south-1.amazonaws.com/dev/api/";  //service

 var dashboardurl="https://r8yrhx04cb.execute-api.ap-south-1.amazonaws.com/dev/api/";  //

 var sbm_app_api="https://z2rjbxsbii.execute-api.ap-south-1.amazonaws.com/dev/api/"; //sbm-app-api   

 var rider="https://l8olgbtnbj.execute-api.ap-south-1.amazonaws.com/dev/api/"; //rider

 var apiurllocal="http://localhost:3000/dev/api/";
 

// import Vue from 'vue'
//var querystring = require('querystring');
import axios from 'axios'
// import store from '../store'

import { authHeader } from '../helpers/auth-header';

let header = authHeader()
// var header={
//     headers: {
//       "Content-Type": "application/json",
//       "Authorization": localStorage.getItem("token")
// }};
export default {
    
    login(data)
    {
        return axios.post(admin + "user/userlogin", JSON.stringify(data),  header)
    },
    vehiclelist(data)
    {
        return axios.post( admin+ "vehicles/adminVehicleList", JSON.stringify(data),  header)
    },
    dashboardRideData(data)
    {
        return axios.post(admin + "user/adminDashboardRideData", JSON.stringify(data),  header)
    },
    dashboardcount(data)
    {
        return axios.post(admin + "user/adminDashboardData", JSON.stringify(data),  header)
    },
    userlist(data)
    {
        return axios.post(admin + "user/userList", JSON.stringify(data),  header)
    },
    
    sosAlertMaster(data)
    {
        return axios.post(admin + "user/adminuserNotification", JSON.stringify(data),  header)
    },
    todaysTravelListDashboard(data)
    {//Data/subjectlist
        return axios.post(admin + "userRide/todaysTravelListDashboard",JSON.stringify(data),   header)
    },
    adminUserProfile(data)
    {//Data/subjectlist
        return axios.post(admin + "user/adminUserProfile",JSON.stringify(data),   header)
    },
    vehicleDriverList(data)
    {
        return axios.post(admin + "vehicles/vehicleDriverList",JSON.stringify(data),   header)
    },
    searchDriverVehicleAdd(data)
    {
        return axios.post(admin + "user/searchDriverVehicleAdd",JSON.stringify(data),   header)
    },
    searchGroupVehicleAdd(data)
    {
        return axios.post(admin + "user/searchGroupVehicleAdd",JSON.stringify(data),   header)
    },
    addDriverVehicle(data)
    {
        return axios.post(admin + "vehicles/addDriverVehicle",JSON.stringify(data),   header)
    },
    activateVehicleDriver(data)
    {
        return axios.post(admin + "userRide/activateVehicleDriver",JSON.stringify(data),   header)
    },
    rideMaster(data)
    {
        return axios.post(admin + "user/userRideMaster",JSON.stringify(data),   header)
    },
    deleteusermaster(data)
    {
        return axios.post(admin + "user/deleteUser", JSON.stringify(data),  header)
    },
    adminsendpushnotification(data)
    {
        return axios.post(admin + "user/adminsendpushnotification", JSON.stringify(data),  header)
    },
    superset_login()
    {
        return axios.post('http://3.6.82.223:8088/api/v1/security/login',JSON.stringify({  "password": "admin",
        "provider": "db",
        "refresh": true,
        "username": "admin"}),header)
    },
    superset_api(data)
    {
        return axios.post(admin+"user/getsupersettoken", JSON.stringify(data),  header);       
           
    } ,
    group_list(data)
    {
        return axios.post(admin+"user/groupList", JSON.stringify(data),  header); 
    },
    delete_group_master(data)
    {
        return axios.post(admin+"user/deletegroupmaster", JSON.stringify(data),  header)
    },
    geocodelats(data)
    {
        return axios.post(admin+"user/geocodelats", JSON.stringify(data),  header);
    },
    geocodelocationdetails(data)
    {
        return axios.post(admin+"user/geocodelocationdetails", JSON.stringify(data),  header);
    },
    addgroup(data)
    {
        return axios.post(admin+"user/addgroup", JSON.stringify(data),  header)
    },
    editgroup(data)
    {
        return axios.post(admin+"user/edit_group", JSON.stringify(data),  header)
    },
    groupUserListget(data)
    {
        return axios.post(admin+"vehicles/groupUserList", JSON.stringify(data),  header)
    },
    groupVehicleListget(data)
    {
        return axios.post(admin+"vehicles/groupVehicleList", JSON.stringify(data),  header)
    },
    addUsersToGroup(data)
    {
        return axios.post(admin+"vehicles/addUsersToGroup", JSON.stringify(data),  header)
    },
    mappedVehcielGroup(data)
    {
        return axios.post(admin+"vehicles/mappedVehcielGroup", JSON.stringify(data),  header)
    },
    unmappedVehcielGroup(data)
    {
        return axios.post(admin+"vehicles/unmappedVehcielGroup", JSON.stringify(data),  header)
    },
    add_group_stops(data)
    {
        return axios.post(admin+"user/add_group_stops", JSON.stringify(data),  header)
    },
    delete_group_stops(data)
    {
        return axios.post(admin+"user/delete_group_stops", JSON.stringify(data),  header)
    },
    getMenuList(data)
    {
        return axios.post(admin+"user/getMenuList", JSON.stringify(data),  header)
    },
    getRoleList(data)
    {
        return axios.post(admin+"user/getRoleList", JSON.stringify(data),  header)
    },
    addrole(data)
    {
        return axios.post(admin +"user/addrole", JSON.stringify(data),  header)
    },
    editrole(data)
    {
        return axios.post(admin +"user/editrole", JSON.stringify(data),  header)
    },
    deleterolemaster(data)
    {
        return axios.post(admin +"user/deleterole", JSON.stringify(data),  header)
    },
    getMenuListMaster(data)
    {
        return axios.post(admin+"user/getMenuListMaster", JSON.stringify(data),  header)
    },
    addmenu(data)
    {
        return axios.post(admin +"user/addmenu", JSON.stringify(data),  header)
    },
    editmenu(data)
    {
        return axios.post(admin +"user/editmenu", JSON.stringify(data),  header)
    },
    deletemenumaster(data)
    {
        return axios.post(admin +"user/deletemenu", JSON.stringify(data),  header)
    },
    saveRoleMenuMapping(data)
    {
        return axios.post(admin+"user/saveRoleMenuMapping", JSON.stringify(data),  header)
    },
    user_rolelist(data)
    {
        return axios.post(admin+"user/user_rolelist", JSON.stringify(data),  header)
    },
    addclient(data)
    {
        return axios.post(admin+"user/addclient", JSON.stringify(data),  header)
    },
    editclient(data)
    {
        return axios.post(admin+"user/editclient", JSON.stringify(data),  header)
    },
    edituser(data)
    {
        return axios.post(admin+"user/edituser", JSON.stringify(data),  header)
    },
    regUser(data)
    {
        return axios.post(admin+"user/regUser", JSON.stringify(data),  header)
    },
    clientdepartmentlist(data)
    {
        return axios.post(admin+"clientdepartment/clientdepartmentlist", JSON.stringify(data),  header)
    },
    clientDepartmentAdd(data)
    {
        return axios.post(admin+"clientdepartment/clientDepartmentAdd", JSON.stringify(data),  header)
 
    },
    clientDepartmentUpdate(data)
    {
        return axios.post(admin+"clientdepartment/clientDepartmentUpdate", JSON.stringify(data),  header)

    },
    client_DepartmentDelete(data)
    {
        return axios.post(admin+"clientdepartment/clientDepartmentDelete", JSON.stringify(data),  header)

    },
    groupList(data)
    {
        return axios.post(admin+"user/groupList", JSON.stringify(data),  header)

    },
    clientDepartmentMappGroup(data)
    {
        return axios.post(admin+"clientdepartment/clientDepartmentMappGroup", JSON.stringify(data),  header)

    },
    getclientist(data)
    {
        return axios.post(admin+"user/getclientist", JSON.stringify(data),  header)
    },
    department_grouplist(data)
    {
        return axios.post(admin+"user/department_group_list", JSON.stringify(data),  header)
    },

    editvehicle(data)
    {   
        return axios.post(admin+"vehicles/vehicleEdit", JSON.stringify(data),  header)
    },
    addvehicle(data)
    {   
        return axios.post(admin+"vehicles/vehicleReg", JSON.stringify(data),  header)
    },
    vehicle_type_master(data)
    {   
        return axios.post(admin+"vehicles/get_vehicle_type_master", JSON.stringify(data),  header)
    },
    vehicle_list_by_client_id(data)
    {   
        return axios.post(admin+"vehicles/vehicle_list_by_client_id", JSON.stringify(data),  header)
    },
    searchhireVehicleAdd(data)
    {   
        return axios.post(admin+"user/searchhireVehicleAdd", JSON.stringify(data),  header)
    },
    

    uploadFile(data)
    {
       return axios.post(admin + "getSignedUrlsgb/getSignedURL", JSON.stringify(data),  header)
    },

    HireVehicleList(data)
    {
       return axios.post(admin + "vehicles/HireVehicleList", JSON.stringify(data),  header)
    },

    vehicles_group_list(data)
    {
       return axios.post(admin + "vehicles/vehicles_group_list", JSON.stringify(data),  header)
    },

    unmap_vehicle_route(data)
    {
       return axios.post(admin + "vehicles/unmap_vehicle_route", JSON.stringify(data),  header)
    },
    get_client_type_master(data)
    {
       return axios.post(admin + "vehicles/get_client_type_master", JSON.stringify(data),  header)
    },
    clientDashboard(data)
    {
       return axios.post(admin + "user/clientDashboardData", JSON.stringify(data),  header)
    },
    fmDashboardData(data)
    {
       return axios.post(admin + "user/fmDashboardData", JSON.stringify(data),  header)
    },
    ServiceList(data)
    {
       return axios.post(admin + "vehicles/UserServiceList", JSON.stringify(data),  header)
    },
    serviceRequestList(data)
    {
       return axios.post(admin + "user/serviceRequestList", JSON.stringify(data),  header)
    },
    deleteservicedata(data)
    {
       return axios.post(admin + "vehicles/deleteservice", JSON.stringify(data),  header)
    },
    UserServicereqList(data)
    {
       return axios.post(admin + "vehicles/UserServicerequestList", JSON.stringify(data),  header)
    },
    getRideDataLive(data)
    {
       return axios.post(admin + "user/getRideDataLive", JSON.stringify(data),  header)
    },
    get_RideDataHistory(data)
    {
       return axios.post(admin + "user/getRideData", JSON.stringify(data),  header)
    },
    bulkvehicleupload_save(data)
    {
       return axios.post(admin + "vehicles/bulkvehicleupload", JSON.stringify(data),  header)
    },
    bulkuserupload_save(data)
    {
       return axios.post(admin + "user/bulkuserupload", JSON.stringify(data),  header)
    },
    deletevehicle(data)
    {
       return axios.post(admin + "vehicles/vehicleDelete", JSON.stringify(data),  header)
    },
    RoleGroupMasterList(data)
    {
       return axios.post(admin + "user/RoleGroupMasterList", JSON.stringify(data),  header)
    },

    departmentVehicleListget(data)
    {
        return axios.post(admin+"vehicles/departmentVehicleList", JSON.stringify(data),  header)
    },
    mappedVehcielDepartment(data)
    {
        return axios.post(admin+"vehicles/mappedVehcielDepartment", JSON.stringify(data),  header)
    },
    getStateData(data)
    {
        return axios.post(service+"masters/getStateData", JSON.stringify(data),  header)
    },
    getBlockData(data)
    {
        return axios.post(service+"masters/getBlockData", JSON.stringify(data),  header)
    },
    getVillageData(data)
    {
        return axios.post(service+"masters/getVillageData", JSON.stringify(data),  header)
    },
    getFamilyData(data)
    {
        return axios.post(service+"masters/getFamilyData", JSON.stringify(data),  header)
    },
    getRideGroupStopData(data)
    {
        return axios.post(service+"ride/userRideDetails", JSON.stringify(data),  header)
    },
    getComplaintList(data)
    {
        return axios.post(service+"masters/getComplaintList", JSON.stringify(data),  header)
    },
    getComplaintTypeList(data)
    {
        return axios.post(service+"masters/getComplaintTypeList", JSON.stringify(data),  header)
    },
    getComplaintStatusList(data)
    {
        return axios.post(service+"masters/getComplaintStatusList", JSON.stringify(data),  header)
    },
    getstoptype(data)
    {
        return axios.post(service+"ride/stoptypemaster", JSON.stringify(data),  header)
    },
    getstopsubtype(data)
    {
        return axios.post(service+"ride/stopsubtypemaster", JSON.stringify(data),  header)
    },
    group_stop_list(data)
    {
        return axios.post(service+"masters/groupStopList", JSON.stringify(data),  header); 
    },
    VehicleStatusMaster(data)
    {
        return axios.post(service+"masters/VehicleStatusMaster", JSON.stringify(data),  header); 
    },
    eventList(data)
    {
        return axios.post(service+"user/eventList", JSON.stringify(data),  header); 
    },
    addevent(data)
    {
        return axios.post(service+"user/addevent", JSON.stringify(data),  header); 
    },
    editevent(data)
    {
        return axios.post(service+"user/editevent", JSON.stringify(data),  header); 
    },
    deleteevent(data)
    {
        return axios.post(service+"user/deleteevent", JSON.stringify(data),  header); 
    },
    vehiclelistDashboard(data)
    {
        return axios.post(dashboardurl+"ride/vehiclelistDashboard", JSON.stringify(data),  header); 
    },
    vehicleRideList(data)
    {
        return axios.post(dashboardurl+"ride/vehicleRideList", JSON.stringify(data),  header); 
    },
    updateComplaintStatus(data)
    {
        return axios.post(service+"masters/updateComplaintStatus", JSON.stringify(data),  header); 
    },
    WardMaster(data)
    {
        return axios.post(service+"masters/WardMaster", JSON.stringify(data),  header); 
    },
    WardMaster_list(data)
    {
        return axios.post(service+"masters/WardMaster_list", JSON.stringify(data),  header); 
    },
    Add_WardMaster(data)
    {
        return axios.post(service+"masters/addward", JSON.stringify(data),  header); 
    },
    edit_WardMaster(data)
    {
        return axios.post(service+"masters/editward", JSON.stringify(data),  header); 
    },
    stateMaster(data)
    {
        return axios.post(service+"user/stateMaster", JSON.stringify(data),  header); 
    },
    Out_Garbage_list(data)
    {   //sbm_app_api
        return axios.post(sbm_app_api+"waste/Out_Garbage_list", JSON.stringify(data),  header); 
    },
    add_Out_Garbage(data)
    {
        return axios.post(sbm_app_api+"waste/add_Out_Garbage", JSON.stringify(data),  header); 
    },
    get_material_type_master(data)
    {
        return axios.post(sbm_app_api+"waste/material_type_master", JSON.stringify(data),  header); 
    },
    segregation_list(data)
    {   //sbm_app_api
        return axios.post(sbm_app_api+"waste/segregation_list", JSON.stringify(data),  header); 
    },
    add_segregation(data)
    {
        return axios.post(sbm_app_api+"waste/add_segregation", JSON.stringify(data),  header); 
    },
    edit_segregation(data)
    {
        return axios.post(sbm_app_api+"waste/edit_segregation", JSON.stringify(data),  header); 
    },
    edit_Out_Garbage(data)
    {
        return axios.post(sbm_app_api+"waste/edit_Out_Garbage", JSON.stringify(data),  header); 
    },
    group_stop_master(data)
    {
        return axios.post(sbm_app_api+"Route/group_stop_master", JSON.stringify(data),  header); 
    },
    getAlertList(data)
    {
        return axios.post(sbm_app_api+"alert/AlertList", JSON.stringify(data),  header)
    },
    getAlertTypeList(data)
    {
        return axios.post(sbm_app_api+"alert/getAlertTypeList", JSON.stringify(data),  header)
    },
    getAlertStatusList(data)
    {
        return axios.post(sbm_app_api+"alert/getAlertStatusList", JSON.stringify(data),  header)
    },
    updateAlertStatus_info(data)
    {
        return axios.post(sbm_app_api+"alert/updateAlertStatus_info", JSON.stringify(data),  header); 
    },
    approval_dropdown(data)
    {
        return axios.post(sbm_app_api+"complaint/approvaldropdown", JSON.stringify(data),  header); 
    },
    add_approval_log(data)
    {
        return axios.post(sbm_app_api+"complaint/addapprovallog", JSON.stringify(data),  header); 
    },
    approval_log_history(data)
    {
        return axios.post(sbm_app_api+"complaint/approvalloghistory", JSON.stringify(data),  header); 
    },
    reject_reason(data)
    {
        return axios.post(sbm_app_api+"complaint/rejectreason", JSON.stringify(data),  header); 
    },
    EmployeeAttendanceList(data)
    {
        return axios.post(sbm_app_api+ "attendance/EmployeeAttendanceList", JSON.stringify(data),  header); 
    },
    In_Out_Garbage_list(data)
    {   
        return axios.post(sbm_app_api+"waste/In_Out_Garbage_list", JSON.stringify(data),  header); 
    },
    add_In_Out_Garbage(data)
    {
        return axios.post(sbm_app_api+"waste/add_In_Out_Garbage", JSON.stringify(data),  header); 
    },
    edit_In_out_Garbage(data)
    {
        return axios.post(sbm_app_api+"waste/edit_In_out_Garbage", JSON.stringify(data),  header); 
    },
    getPanchayatData(data)
    {
        return axios.post(sbm_app_api+"masters/getPanchayatData", JSON.stringify(data),  header);    
    },
    centerList(data)
    {
        return axios.post(sbm_app_api+"garbage/GarbageProcessingCentersList", JSON.stringify(data),  header);         
    },
    centerType(data)
    {
        return axios.post(sbm_app_api+"garbage/GarbageProcessingCentersType", JSON.stringify(data),  header);       
    },
    deletecenter(data)
    {
        return axios.post(sbm_app_api+"garbage/GarbageProcessingCentersDelete", JSON.stringify(data),  header);         
    },
    editcenter(data)
    {
        return axios.post(sbm_app_api+"garbage/GarbageProcessingCentersEdit", JSON.stringify(data),  header);         
    },
    addcenter(data)
    {
        return axios.post(sbm_app_api+"garbage/GarbageProcessingCentersAdd", JSON.stringify(data),  header);    
    },
    addFamily(data)
    {
        return axios.post(sbm_app_api+"family/StopFamilyAdd", JSON.stringify(data),  header);
        
    },
    editFamily(data)
    {
        return axios.post(sbm_app_api+"family/StopFamilyEdit", JSON.stringify(data),  header);
        
    },
    StopQrEdit(data)
    {
        return axios.post(sbm_app_api+"family/StopFamilyEdit1", JSON.stringify(data),  header);
    },
    track_report_master(data)
    {
         return axios.post(sbm_app_api+"track/track_report_master", JSON.stringify(data),  header);
        //return axios.post("http://localhost:3000/dev/api/track/track_report_master", JSON.stringify(data),  header);
    },
    StopRouteMap(data)
    {
        return axios.post(sbm_app_api+"track/StopRouteMapp", JSON.stringify(data), header);
    },
    advertizeList(data)
    {
        return axios.post(sbm_app_api+"advertize/advertize_master_list", JSON.stringify(data),  header); 
    },
    addadvertize(data)
    {   
        return axios.post(sbm_app_api+"advertize/advertize_master_add", JSON.stringify(data),  header);
    },
    editadvertize(data)
    {   
        return axios.post(sbm_app_api+"advertize/advertize_master_edit", JSON.stringify(data),  header);
    },
    deleteadvertize(data)
    {   
        return axios.post(sbm_app_api+"advertize/advertize_master_delete", JSON.stringify(data),  header);
    },
    vehicle_add(data)
    {
         return axios.post(sbm_app_api+"vehicle/VehicleAdd", JSON.stringify(data),  header);
    },
    upload_receipt(data)
    {
         return axios.post(admin+"getSignedUrlsgb/getSignedURL", JSON.stringify(data),  header);
    },
    update_receipt_photo(data)
    {
         return axios.post(sbm_app_api+"masters/update_receipt_photo", JSON.stringify(data),  header);
         //return axios.post("http://localhost:3000/dev/api/masters/update_receipt_photo", JSON.stringify(data),  header);
    },
    GetSummaryChart(data)
    {
         return axios.post(sbm_app_api+"masters/GetSummaryChart", JSON.stringify(data),  header);
         //return axios.post("http://localhost:3000/dev/api/masters/GetSummaryChart", JSON.stringify(data),  header);
    },
    GetSummaryMonthlyChart(data)
    {
         return axios.post(sbm_app_api+"masters/GetSummaryMonthlyChart", JSON.stringify(data),  header);
         //return axios.post("http://localhost:3000/dev/api/masters/GetSummaryMonthlyChart", JSON.stringify(data),  header);
    },
    GetTotalSubmissions(data)
    {
         return axios.post(sbm_app_api+"masters/GetTotalSubmissions", JSON.stringify(data),  header);
         //return axios.post("http://localhost:3000/dev/api/masters/GetTotalSubmissions", JSON.stringify(data),  header);
    },
    GetTotalFilterSubmissions(data)
    {
         return axios.post(sbm_app_api+"masters/GetTotalFilterSubmissions", JSON.stringify(data),  header);
         //return axios.post("http://localhost:3000/dev/api/masters/GetTotalFilterSubmissions", JSON.stringify(data),  header);
    },
    GetReceiptPhotos(data)
    {
         return axios.post(sbm_app_api+"masters/GetReceiptPhotos", JSON.stringify(data),  header);
         //return axios.post("http://localhost:3000/dev/api/masters/GetReceiptPhotos", JSON.stringify(data),  header);
    },
    generateqr(data)
    {
        return axios.post(rider + "user/generateqr", JSON.stringify(data),  header)
    },
    lockunlockVehicle(data)
    {
        return axios.post(rider + "user/lockunlockVehicle", JSON.stringify(data),  header)
    },
    stopgenerateqr(data)
    {
        return axios.post(rider + "user/stopgenerateqr", JSON.stringify(data),  header)
    },

    //QR_survey API 
    Submit_Survey(data)
    {
        return axios.post(service + "user/updatePosStopScan", JSON.stringify(data),  header)
    },


}